<!-- Pagination：2019-06-11 YuAng-->

<template>
    <div class="ya-pagination" v-if="totalCount > 0">
        <el-pagination
                background
                @current-change="pageChange"
                :current-page="currentPage"
                :pager-count="5"
                :page-size="pageSize"
                layout="total, slot, prev, pager, next"
                :total="totalCount" v-if="pageSize > 0">
            <slot>
                <span class="el-pagination__total">{{pageSize}}条/页</span>
            </slot>
        </el-pagination>
        <p v-else-if="totalCount > 0 && pageSize == -1" style="color: #999999;float: right">,共{{totalCount}}条记录</p>
    </div>
</template>

<script>
    export default {
        name: 'Pagination',
        props: {
            currentPage: {
                default: 1
            },
            pageSize: {
                default: 8
            },
            totalCount: {
                default: 100
            },
            fatherAction: {
                type: Function,
                default: null
            }
        },
        methods: {
            pageChange: function (data) {
                if (this.fatherAction) {
                    this.fatherAction(data)
                }
            }
        }
    }
</script>

<style scoped>
    .ya-pagination {
        padding: 20px 10px 20px 20px;
    }
    .ya-pagination .el-pagination {
        text-align: right;
    }

    .ya-pagination .el-pagination.is-background .el-pager li:not(.disabled).active {
        color: #5591fe;
    }

    .ya-pagination .el-pagination.is-background .btn-next,
    .ya-pagination .el-pagination.is-background .btn-prev,
    .ya-pagination .el-pagination.is-background .el-pager li {
        background-color: white !important;
        border-color: #cfcfcf !important;
    }
</style>
